import React, { useState, useEffect } from 'react'
import { Route } from 'react-router-dom'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from "react-redux";
import { authSuccess } from "../../redux/actions/authActions";
import { RouterPathApp } from './RoutesPathApp';
import { cleanDetailMultimediaSuccess } from "../../redux/actions/InsuranceActions";
import { getMe } from "../../api/authApi";
import { setDatadogUser } from "../../services/datadog";

export const PrivateRoute = (props) => {
  const { layout: Layout, component: Component, image, imageStyle, direction, path, ...rest } = props;
  const dispatch = useDispatch();
  const authState = useSelector(state => state.auth);
  const currentUser = authState?.data?.user;
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

  // If no user in Redux, try to restore session from backend
  useEffect(() => {
    if (!currentUser && !hasCheckedAuth) {
      // Call /me to check if backend has a valid session
      getMe({ credentials: 'include' })
        .then(response => {
          if (response?.data) {
            dispatch(authSuccess({ data: { user: response.data }, token: null }));
            // Set Datadog user context on session restoration
            try {
              setDatadogUser(response.data);
            } catch (ddError) {
              console.error('Error setting Datadog user on session restore:', ddError);
            }
          }
        })
        .catch(() => {
          // No valid session - user will be redirected to login
        })
        .finally(() => {
          setHasCheckedAuth(true);
        });
    }
    // Only depend on hasCheckedAuth to avoid infinite loop when currentUser changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, hasCheckedAuth]);

  // Wait for auth check to complete before rendering
  if (!currentUser && !hasCheckedAuth) {
    return null;
  }

  if (path === "/insurance/housing" || path === "/insurance/health-mobility") {
    dispatch(cleanDetailMultimediaSuccess());
  }

  const validateRoles = (pathList) => {
    for (const key in pathList) {
      if (pathList[key].href && pathList[key].href === window.location.pathname) {
        return currentUser.roles.some(r => pathList[key].roles.indexOf(r) >= 0);
      } else if (window.location.pathname.startsWith(pathList[key].href)) {
        return validateRoles(pathList[key].items);
      }
    }
    return false;
  };

  const validateDataCurrentUser = () => {
    if (!currentUser || !currentUser.email) {
      return false;
    }

    const isRoleOk = validateRoles(RouterPathApp);

    if (!isRoleOk) {
      return false;
    }

    return true;
  };

  return validateDataCurrentUser() ? (
    <Route {...rest} render={(matchProps) => (
      <Layout image={image} imageStyle={imageStyle} direction={direction}>
        <Component {...matchProps} />
      </Layout>
    )} />
  ) : (
    <Redirect to="/login/classic" />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
  image: PropTypes.string,
  imageStyle: PropTypes.string,
  direction: PropTypes.string,
}